import React from "react";
export const TermsOfService = () => {
  return <div className="py-20 bg-white" data-id="element-1425">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1426">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1427">
          Terms of Service
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-1428">
          <p className="text-gray-600 mb-8" data-id="element-1429">Last updated: Feb 2025</p>
          <section className="mb-12" data-id="element-1430">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1431">
              1. Who We Are
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1432">
              Ready Set Sell SRL ("we," "us," or "our") operates usegigi.ai.
              We're registered in Romania (CUI: RO47089455, Nr. Inreg:
              J40/21559/29.10.2022) with our headquarters at Intrarea Gheorghe
              Simionescu nr 19, Apt. B26, Sector 1, Bucuresti, Romania, 014155.
            </p>
            <p className="text-gray-600" data-id="element-1433">
              For legal matters, reach us at ready@set-sell.com
            </p>
          </section>
          <section className="mb-12" data-id="element-1434">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1435">
              2. The Basics
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1436">
              <li data-id="element-1437">You must be at least 18 years old to use Gigi</li>
              <li data-id="element-1438">You need a valid email address to create an account</li>
              <li data-id="element-1439">One account per user (no sharing, sorry!)</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1440">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1441">
              3. How Our Service Works
            </h2>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1442">
              Free Trial & Credits
            </h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6" data-id="element-1443">
              <li data-id="element-1444">Start with 20 free credits per month</li>
              <li data-id="element-1445">Credits don't roll over to the next month</li>
              <li data-id="element-1446">One credit = one personalized outreach sequence</li>
              <li data-id="element-1447">Upgrade needed after free credits are used</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1448">
              Subscriptions & Cancellations
            </h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1449">
              <li data-id="element-1450">Cancel your subscription anytime</li>
              <li data-id="element-1451">No refunds for unused credits</li>
              <li data-id="element-1452">Service continues until the end of your billing period</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1453">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1454">
              4. Data & Privacy
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1455">
              <li data-id="element-1456">
                We need LinkedIn access for automated campaigns (optional)
              </li>
              <li data-id="element-1457">Your data is stored securely and encrypted</li>
              <li data-id="element-1458">We use industry-standard security measures</li>
              <li data-id="element-1459">
                We work with trusted partners: OpenAI, Dux Soup, Smartlead, and
                Sendgrid
              </li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1460">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1461">
              5. Content & Intellectual Property
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1462">
              <li data-id="element-1463">You own the content you create with Gigi</li>
              <li data-id="element-1464">We own our technology, algorithms, and platform</li>
              <li data-id="element-1465">
                AI-generated content is provided "as is" without warranties
              </li>
              <li data-id="element-1466">
                You're responsible for reviewing all AI-generated content before
                use
              </li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1467">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1468">
              6. Platform Guidelines
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1469">
              <li data-id="element-1470">Follow LinkedIn's terms of service</li>
              <li data-id="element-1471">No spamming or harassment</li>
              <li data-id="element-1472">Respect rate limits and platform guidelines</li>
              <li data-id="element-1473">We may suspend accounts that violate these terms</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1474">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1475">
              7. Changes & Updates
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1476">
              We may update these terms as our service evolves. We'll notify you
              of significant changes via email. Continued use of Gigi after
              changes means you accept the new terms.
            </p>
          </section>
          <section className="mb-12" data-id="element-1477">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1478">
              8. Dispute Resolution
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1479">
              Any disputes will be resolved under Romanian law. We prefer to
              handle things amicably - reach out to us first if you have
              concerns.
            </p>
          </section>
          <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1480">
            <p className="text-gray-500 text-sm" data-id="element-1481">
              Questions about these terms? Contact us at ready@set-sell.com
            </p>
          </div>
        </div>
      </div>
    </div>;
};